import { Layer } from "./Layer";
class DataMapper extends Layer {
    constructor(isMutable, inLayer) {
        super([]);
        this.mappedData = Object.create(null);
        this.isMutable = isMutable;
        this.inLayer = inLayer;
    }
    activate() {
        for (const key of Object.keys(this.mappedData)) {
            delete this.mappedData[key];
        }
        const inData = this.inLayer.data;
        for (const key of Object.keys(inData)) {
            this.mappedData[key] = this.createData(key, inData[key], null);
        }
        this.onActivateAfterCreateObjects();
        for (const key of Object.keys(inData)) {
            if (this.isMutable) {
                this.updateData(key, inData[key], null);
            }
        }
    }
    onActivateAfterCreateObjects() { }
    close() {
    }
    getLayerData() {
        return this.mappedData;
    }
    update(inEvent) {
        const key = inEvent.key;
        let eventToReturn = null;
        if (inEvent.type === 'Created') {
            if (this.mappedData[key] === undefined) {
                this.mappedData[key] = this.createData(key, inEvent.newData, null);
            }
            if (this.isMutable) {
                this.updateData(key, inEvent.newData, null);
            }
            eventToReturn = {
                type: 'Created',
                key: inEvent.key,
                oldData: null,
                newData: this.mappedData[key],
            };
        }
        if (inEvent.type === 'Updated') {
            const oldData = this.mappedData[key];
            if (this.isMutable) {
                this.updateData(inEvent.key, inEvent.newData, inEvent.oldData);
            }
            else {
                this.mappedData[key] = this.createData(key, inEvent.newData, inEvent.oldData);
            }
            eventToReturn = {
                type: 'Updated',
                key: inEvent.key,
                oldData,
                newData: this.mappedData[key],
            };
        }
        if (inEvent.type === 'Deleted') {
            const oldData = this.mappedData[key];
            if (this.mappedData[key] !== undefined) {
                delete this.mappedData[key];
            }
            eventToReturn = {
                type: 'Deleted',
                key: inEvent.key,
                oldData,
                newData: null,
            };
        }
        return (this.isMutable ? null : eventToReturn);
    }
    onDeleteData(key, oldData) { }
    ;
}
export class MutableDataMapper extends DataMapper {
    constructor(inLayer) {
        super(true, inLayer);
    }
}
export class ImmutableDataMapper extends DataMapper {
    constructor(inLayer) {
        super(false, inLayer);
    }
    updateData() {
    }
}
function classToFn(input) {
    return (...args) => new input(...args);
}
export function mapperClassRecordToFnRecord(input) {
    const result = Object.create(null);
    for (const key of Object.keys(input)) {
        result[key] = classToFn(input[key]);
    }
    return result;
}
export class ClassBasedMutableDataMapper extends MutableDataMapper {
    constructor(builderMap, inLayer) {
        super(inLayer);
        this.builderMap = builderMap;
    }
    createData(key, data, oldData) {
        return this.builderMap[data.className](key, data, oldData);
    }
}
export class ClassBasedImmutableDataMapper extends ImmutableDataMapper {
    constructor(builderMap, inLayer) {
        super(inLayer);
        this.builderMap = builderMap;
    }
    createData(key, data, oldData) {
        // console.log(`CreateData. key: ${key}, ClassName: ${data.className}`);
        // console.log('Full data: ');
        // console.log(data);
        // console.log('Map keys: ');
        // console.log(Object.keys(this.builderMap));
        // console.log('Map entry: ');
        // console.log(this.builderMap[data.className]);
        return this.builderMap[data.className](key, data, oldData);
    }
}
//# sourceMappingURL=DataMapper.js.map